import { render } from "./Sessions.vue?vue&type=template&id=0e50e073&scoped=true"
import script from "./Sessions.vue?vue&type=script&lang=js"
export * from "./Sessions.vue?vue&type=script&lang=js"

import "./Sessions.vue?vue&type=style&index=0&id=0e50e073&lang=scss&scoped=true"

import exportComponent from "/home/artur/Documents/bemyvega-gitlab/platform-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e50e073"]])

export default __exports__